export default [
  {
    path: "/settings/zenhr",
    name: "ZenHRIntegration",
    component: () => import("@/views/zenhr-integrations/index.vue"),
    meta: {
      label: "ZenHR Integration",
      permission: "show_zenhr_integration",
    },
  },
  {
    path: "/settings/zenhr/new-users",
    name: "ZenHRNewUsers",
    component: () => import("@/views/zenhr-integrations/NewUsers.vue"),
    meta: {
      label: "ZenHR New Users",
      permission: "show_zenhr_integration",
    },
  },
];
